import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.code === 'ERR_NETWORK' || e?.message === 'Network Error' ? 'Geen verbinding met de webshop. Probeer het opnieuw.' : 'Er ging iets mis. Probeer het opnieuw.';
  if (typeof d === 'string') return ({ 'Not Found': 'Niet gevonden.', 'Unauthorized': 'Log opnieuw in.', 'Forbidden': 'Je hebt hiervoor geen toegang.' })[d] || d;
  if (Array.isArray(d)) return d.map(x => x?.msg || 'Controleer de ingevulde gegevens.').join(' ');
  return d.msg || 'Controleer de ingevulde gegevens.';
};

export function dutchInvalid(event) {
  const field = event.target;
  if (!field.validity || !field.setCustomValidity) return;
  const v = field.validity;
  const message = v.valueMissing ? (field.type === 'checkbox' ? 'Vink dit aan om verder te gaan.' : 'Vul dit veld in.')
    : v.typeMismatch && field.type === 'email' ? 'Vul een geldig e-mailadres in.'
    : v.rangeOverflow ? `Vul een waarde in van maximaal ${field.max}.`
    : v.rangeUnderflow ? `Vul een waarde in van minimaal ${field.min}.`
    : v.patternMismatch ? 'Controleer het formaat van dit veld.'
    : v.tooShort ? `Gebruik minimaal ${field.minLength} tekens.`
    : v.stepMismatch || v.badInput ? 'Vul een geldig getal in.' : 'Controleer dit veld.';
  field.setCustomValidity(message);
}
export const clearDutchValidity = event => event.target.setCustomValidity?.('');

export const euro = (cents) =>
  cents == null ? "–" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(cents / 100);

export const parseEuroCents = (value, { allowZero = false } = {}) => {
  const raw = String(value).trim();
  if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d{1,2})?$/.test(raw)) throw new Error('Vul een geldig bedrag in, bijvoorbeeld 1.234,56.');
  const [whole, decimals = ''] = raw.replaceAll('.', '').split(',');
  const cents = Number(whole) * 100 + Number(decimals.padEnd(2, '0'));
  if (!Number.isSafeInteger(cents) || cents < 0 || (!allowZero && cents === 0)) throw new Error('Vul een geldig positief bedrag in.');
  return cents;
};

export const nlNum = (n, d = 2) => (n == null ? "–" : Number(n).toLocaleString("nl-NL", { maximumFractionDigits: d }));

export const EXTRA_GROUPS = [["lijm", "/lijmen", "Lijmen", "Lijm"], ["dekvloer", "/dekvloeren-egaline", "Dekvloeren & egaline", "Dekvloer & egaline"], ["legmateriaal", "/legmaterialen", "Legmaterialen", "Legmateriaal"], ["onderhoud", "/onderhoud", "Onderhoud", "Onderhoudsproduct"], ["afdekmateriaal", "/afdekmateriaal", "Afdekmateriaal", "Afdekmateriaal"]];
export const OTHER_GROUPS = [["hout", "/houten-vloeren", "Houten vloeren", "Houten vloer"], ["keramiek", "/keramische-tegels", "Keramische tegels", "Keramische tegel"], ["traprenovatie", "/traprenovatie", "Traprenovatie", "Traponderdeel"]];
export const ACC_GROUPS = ["ondervloer", "plint", "profiel", ...EXTRA_GROUPS.map((g) => g[0])];
const SUB_FIX = { "polyurethaan-pu": "Polyurethaan (PU)", "kitten-op-kleur": "Kit op kleur", "siliconen-kit": "Siliconenkit", "pvc-vloer": "PVC-vloer", "kunst-leer": "Kunststof & leer", "meubelstof-tapijt": "Meubelstof & tapijt", "parket-entree-matten": "Entreematten", "egaline": "Egaline", "scharen-stanzen-en-messen": "Scharen, stanzen & messen", "meet-en-aftekengereedschap": "Meet- & aftekengereedschap", "pads-en-gaasschijven": "Pads & gaasschijven", "rollers-en-kwasten": "Rollers & kwasten", "brads-en-nieten": "Brads & nieten", "kitten-en-lijmen": "Kitten & lijmen", "mixers-en-roerstaven": "Mixers & roerstaven", "schuren-en-lijm-verwijderen": "Schuren & lijm verwijderen", "droog-egaliseren": "Droog egaliseren" };
export const subLabel = (k) => SUB_FIX[k] || (k.charAt(0).toUpperCase() + k.slice(1)).replace(/-/g, " ");

export const label = {
  ...Object.fromEntries([...EXTRA_GROUPS, ...OTHER_GROUPS].map((g) => [g[0], g[2]])),
  ondervloer: "Ondervloeren", plint: "Plinten", profiel: "Profielen", zwevend: "Zwevend", verlijmd: "Verlijmd", plak: "Plak PVC", click: "Click PVC", "loose-lay": "Loose lay PVC", laminaat: "Laminaat",
  "rechte-stroken": "Rechte stroken", visgraat: "Visgraat", walvisgraat: "Walvisgraat", "hongaarse-punt": "Hongaarse punt",
  "weense-punt": "Weense punt", tegel: "Tegel", pvc: "PVC-vloeren",
};

export const statusNl = {
  pending_payment: "Wacht op betaling", paid: "Betaald", payment_failed: "Betaling niet gelukt", canceled: "Geannuleerd",
  refunded: "Terugbetaald", partially_refunded: "Deels terugbetaald", chargeback: "Terugboeking", paid_attention: "Betaald – controle nodig",
  not_started: "Nog niet gestart", awaiting_route: "Wacht op leverroute", offered: "Aangeboden aan leverancier", confirmed: "Bevestigd door leverancier",
  shipped: "Verzonden", delivered: "Afgeleverd", open: "Open", failed: "Mislukt", expired: "Verlopen", pending: "In behandeling", authorized: "Geautoriseerd",
};
